import React, { FC } from 'react';
import { Grid2 as Grid, Stack } from '@mui/material';

import { MyReleases } from './MyReleases';
import { MyParticipationInRevisions } from './MyParticipationInRevisions';
import { MyCategories } from './MyCategories';
import { CommentsOnMyGuides } from './CommentsOnMyGuides';

export const Overview: FC = () => {
  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        <MyParticipationInRevisions />
      </Grid>
      <Grid size={{ sm: 6 }}>
        <Stack>
          <MyCategories />
          <CommentsOnMyGuides />
        </Stack>
      </Grid>
      <Grid size={{ sm: 6 }}>
        <MyReleases />
      </Grid>
    </Grid>
  );
};
